"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertOptionToDateFilter = void 0;
// (C) 2021-2022 GoodData Corporation
var sdk_ui_filters_1 = require("@gooddata/sdk-ui-filters");
var sdk_model_1 = require("@gooddata/sdk-model");
var ts_invariant_1 = require("ts-invariant");
function convertOptionToDateFilter(option) {
    var _a;
    if (sdk_model_1.isAllTimeDateFilterOption(option)) {
        return;
    }
    if (sdk_ui_filters_1.isAbsoluteDateFilterOption(option)) {
        return {
            dateFilter: {
                type: "absolute",
                granularity: "GDC.time.date",
                from: option.from,
                to: option.to,
            },
        };
    }
    else if (sdk_ui_filters_1.isRelativeDateFilterOption(option)) {
        return {
            dateFilter: {
                type: "relative",
                granularity: (_a = option.granularity) !== null && _a !== void 0 ? _a : "GDC.time.date",
                from: option.from,
                to: option.to,
            },
        };
    }
    throw new ts_invariant_1.InvariantError("Unexpected option type when converting date filter option to filter.");
}
exports.convertOptionToDateFilter = convertOptionToDateFilter;
//# sourceMappingURL=dateFilterOptionConverters.js.map